module.exports = __webpack_public_path__ + "img/IMG_9874-2.5d4d93e7.png";